import { useState, MouseEvent } from "react";
import AdminInterviewsModel from "../../../../models/admin/interviews/response/AdminInterviewsModel";
import UpdateInterviewRequestModel from "../../../../models/admin/interviews/request/UpdateInterviewRequestModel";
import { GuidEnum } from "../../../../models/enums/GuidEnum";
import copyClickboardUtils from "../../../../utils/copy-clipboard";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { Box, IconButton } from "@mui/material";
// import { DataGrid, GridColDef } from "@mui/x-data-grid";

interface InterviewsGridProps {
    candidateList: AdminInterviewsModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    nameFilterValue: string;
    companyNameFilterValue: string;
    onUpdateInterviewAction: (objInterview: UpdateInterviewRequestModel, primarySkillId: number) => void;
    onViewInterviewAction: (objInterview: AdminInterviewsModel) => void;
    onViewRatingAction: (interviewId: string) => void;
    onUpdateFollowupAction: (candidateId: string) => void;
    onCandidateViewHistory: (candidateId: string) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
    onFilterAction: (filterColumn: string, filterValue: string) => void;
}

const InterviewsGridComponent = (props: InterviewsGridProps) => {
    const [nameFilter, setNameFilter] = useState<string>(props.nameFilterValue);
    const [companyNameFilter, setCompanyNameFilter] = useState<string>(props.companyNameFilterValue);

    const copyClipboard = (message: string) => {
        copyClickboardUtils.copy(message);
    };

    const reScheduleInterview = (row: AdminInterviewsModel) => {
        var objCandidate: UpdateInterviewRequestModel = {
            interviewId: row.interviewId,
            interviewDate: new Date(row.interviewDate),
            timeSlotId: row.timeSlotId,
            interviewerId: GuidEnum.Empty,
            userId: GuidEnum.Empty
        };
        props.onUpdateInterviewAction(objCandidate, row.primarySkillId);
    };

    const viewRating = (row: AdminInterviewsModel) => {
        props.onViewRatingAction(row.interviewId);
    };

    const updateComments = (row: AdminInterviewsModel) => {
        props.onUpdateFollowupAction(row.candidateId);
    };

    const viewHistory = (candidateId: string) => {
        props.onCandidateViewHistory(candidateId);
    };

    const columnsCandidates = [
        { key: "InterviewUniqueId", text: "Interview Id", sort: true, searchable: false },
        { key: "InterviewDate", text: "Interview Dt", sort: true, searchable: false },
        { key: "CandidateName", text: "Name", sort: true, searchable: true },
        { key: "EmailId", text: "Email Id", sort: true, searchable: false },
        { key: "MobileNumber", text: "Mobile No", sort: true, searchable: false },
        { key: "InterviewerName", text: "Interviewer", sort: true, searchable: false },
        { key: "PrimarySkillName", text: "Primary Skill", sort: true, searchable: false },
        { key: "TotalRating", text: "Rating", sort: false, searchable: false },
        { key: "CompanyName", text: "Company", sort: true, searchable: false },
        { key: "RecruiterName", text: "Recruiter", sort: false, searchable: false },
        { key: "DesignationName", text: "Designation", sort: true, searchable: false },
        { key: "Status", text: "Status", sort: true, searchable: false },
        { key: "IsRescheduled", text: "Is Rescheduled", sort: false, searchable: false },
        { key: "IAIAdminName", text: "Admin Name", sort: false, searchable: false },
        { key: "MeetingURL", text: "Meeting Link", sort: false, searchable: false },
        { key: "Actions", text: "Actions", sort: false, searchable: false }
    ];

    // const columns: GridColDef<(AdminInterviewsModel)>[] = [
    //     { field: 'interviewUniqueId', headerName: 'Interview Id', editable: false, sortable: false },
    //     { field: "InterviewDate", headerName: "Interview Dt", sortable: true, editable: false },
    //     { field: "CandidateName", headerName: "Name", sortable: true, editable: true },
    //     { field: "EmailId", headerName: "Email Id", sortable: true, editable: false },
    //     { field: "MobileNumber", headerName: "Mobile No", sortable: true, editable: false },
    //     { field: "InterviewerName", headerName: "Interviewer", sortable: true, editable: false },
    //     { field: "PrimarySkillName", headerName: "Primary Skill", sortable: true, editable: false },
    //     { field: "TotalRating", headerName: "Rating", sortable: false, editable: false },
    //     { field: "CompanyName", headerName: "Company", sortable: true, editable: false },
    //     { field: "RecruiterName", headerName: "Recruiter", sortable: false, editable: false },
    //     { field: "DesignationName", headerName: "Designation", sortable: true, editable: false },
    //     { field: "Status", headerName: "Status", sortable: true, editable: false },
    //     { field: "IsRescheduled", headerName: "Is Rescheduled", sortable: false, editable: false },
    //     { field: "IAIAdminName", headerName: "Admin Name", sortable: false, editable: false },
    //     { field: "MeetingURL", headerName: "Meeting Link", sortable: false, editable: false },
    // ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const filterOnChange = (key: string, value: string) => {
        if (key === "CandidateName") {
            setNameFilter(value);
        } else {
            setCompanyNameFilter(value);
        }
        if ((value && value.length > 2) || value === "") {
            props.onFilterAction(key, value);
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsCandidates.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {column.searchable &&
                                            <input type="text" placeholder="search" className="mat-header-filter-input" value={column.key === "CandidateName" ? nameFilter : companyNameFilter}
                                                onClick={(e) => e.stopPropagation()} onChange={(e) => filterOnChange(column.key, e.target.value)}></input>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.candidateList.map((candidate: AdminInterviewsModel, index) => (
                                <TableRow>
                                    <TableCell>
                                        <span>{candidate.interviewUniqueId}</span>
                                        <IconButton color="primary" className="grid-icon-copy-button" onClick={() => { copyClipboard(candidate.interviewUniqueId); }}>
                                            <ContentCopyOutlinedIcon className="grid-icon-copy" />
                                        </IconButton>
                                        {/* <a title="copy" onClick={() => { copyClipboard(candidate.interviewUniqueId); }}><i className="fa fa-clone copy-icon-color"></i></a> */}
                                    </TableCell>
                                    <TableCell>{candidate.interviewDateString}</TableCell>
                                    <TableCell>
                                        {candidate.isRegisteredCandidate &&
                                            <span style={{ color: "green" }}>{candidate.candidateName}</span>
                                        }
                                        {!candidate.isRegisteredCandidate &&
                                            <span>{candidate.candidateName}</span>
                                        }
                                    </TableCell>
                                    <TableCell>{candidate.emailId}</TableCell>
                                    <TableCell>
                                        <span>{candidate.mobileNumber}</span>
                                        <IconButton color="primary" className="grid-icon-copy-button" onClick={() => { copyClipboard(candidate.mobileNumber.toString()); }}>
                                            <ContentCopyOutlinedIcon className="grid-icon-copy" />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>{candidate.interviewerName}</TableCell>
                                    <TableCell>{candidate.primarySkillName}</TableCell>
                                    <TableCell>{candidate.totalRating}</TableCell>
                                    <TableCell>{candidate.companyName}</TableCell>
                                    <TableCell>{candidate.recruiterName}</TableCell>
                                    <TableCell>{candidate.designationName}</TableCell>
                                    <TableCell>{candidate.status}</TableCell>
                                    <TableCell>{candidate.isRescheduled}</TableCell>
                                    <TableCell>{candidate.iaiAdminName}</TableCell>
                                    <TableCell>
                                        {!candidate.isRated && candidate.meetingURL &&
                                            <a href={candidate.meetingURL} target="_blank" title={candidate.meetingURL}>Join Meeting</a>
                                        }
                                        {candidate.isRated &&
                                            <span> --- </span>
                                        }
                                    </TableCell>
                                    <TableCell className="grid-actions">
                                        <a onClick={() => { props.onViewInterviewAction(candidate); }} title="View Interview">
                                            <i className="fa fa-eye grid-icon blue"></i>
                                        </a>
                                        {!candidate.isRated &&
                                            <a onClick={() => { reScheduleInterview(candidate); }} title="Re Schedule">
                                                <i className="fa fa-calendar-plus grid-icon blue"></i>
                                            </a>
                                        }

                                        {candidate.isRated &&
                                            <a onClick={() => { viewRating(candidate); }} title="Rating">
                                                <i className="fa fa-star grid-icon blue"></i>
                                            </a>
                                        }
                                        <a onClick={() => { updateComments(candidate); }} title="Update">
                                            <i className="fa fa-check grid-icon blue"></i>
                                        </a>
                                        <a onClick={() => { viewHistory(candidate.candidateId); }} title="View History">
                                            <i className="fa fa-history grid-icon blue"></i>
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                {/* <Box sx={{ height: 400, width: '100%' }}>
                    <DataGrid
                        rows={props.candidateList}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                            },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection={false}
                        disableRowSelectionOnClick
                    />
                </Box> */}
            </div>
        </div>
    );
};
export default InterviewsGridComponent;